import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Leadership from './components/Leadership';
import Skills from './components/Skills';
import Contact from './components/Contact';
import { profile } from './data/profile';
import { useReveal } from './hooks/useReveal';
import { useSpotlight } from './hooks/useSpotlight';

function App() {
  useReveal();
  useSpotlight();

  return (
    <div className="relative min-h-screen overflow-x-clip">
      <div aria-hidden className="bg-grid pointer-events-none absolute inset-x-0 top-0 h-[760px]" />
      <div
        aria-hidden
        className="animate-glow pointer-events-none absolute left-1/2 top-[-320px] h-[600px] w-[min(1000px,140vw)] -translate-x-1/2 rounded-full bg-accent/[0.08] blur-[120px]"
      />

      <Nav />

      <main className="relative mx-auto max-w-page px-5 sm:px-8">
        <Hero />
        <div className="mt-24 sm:mt-32">
          <Experience />
          <Projects />
          <Leadership />
          <Skills />
          <Contact />
        </div>
      </main>

      <footer className="relative border-t border-ink-700">
        <div className="mx-auto flex max-w-page flex-col gap-2 px-5 py-8 font-mono text-[11px] text-fg-faint sm:flex-row sm:justify-between sm:px-8">
          <span>© {new Date().getFullYear()} {profile.name}</span>
          <span>{profile.location} · Built with React &amp; Tailwind</span>
        </div>
      </footer>
    </div>
  );
}

export default App;
